/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, InputAdornment, FormHelperText } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import Chip from '@material-ui/core/Chip';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Service';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';


var screenCode = "DAILYPURCHASINGEFFICIENCYSUMMARYREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
    const useStyles = makeStyles({
        tableContainer: {
            maxHeight: 440,
        },
    });

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));

export default function DailyPurchasingEfficiencySummaryView(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Daily Purchasing Efficiency Summary Report'
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [datevalue, setDateValue] = useState(new Date());
    const [ytdAndMtdDetails, setytdAndMtdDetails] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [ytdAndMtdData, setytdAndMtdData] = useState({
        ytdAndMtdName: ''
    });

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, ytdAndMtdDetails.length - page * rowsPerPage);

    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        date: null,
        isActive: true
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const DailyPurchasingEfficiencySummaryReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh collection center').min(1, 'Please select at least one Fresh collection center'),
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        factoryName: '',
        date: ''
    });

    const truncateSheetName = (name) => {
        return name.length > 31 ? name.substring(0, 31) : name;
    }

    const [total, setTotalRow] = useState({
        dtnetAmount: 0,
        dtfccPurchaseValue: 0,
        dtpurchaseFromECValue: 0,
        dtValueSaving: 0,
        dtSaving: 0,
        mtdfccPurchaseValue: 0,
        mtdpurchaseFromECValue: 0,
        mtdValueSaving: 0,
        mtdSaving: 0,
        mtdCost: 0,
        mtdNetProfit: 0,
        ytdfccPurchaseValue: 0,
        ytdpurchaseFromECValue: 0,
        ytdValueSaving: 0,
        ytdSaving: 0,
        ytdCost: 0,
        ytdNetProfit: 0,
        totOfinterCenterBuyingExcellenceTotalSaving: 0,
        totNetSavingofFCCOperation: 0
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            date: formData.date,
            isActive: formData.isActive
        },
        validationSchema: DailyPurchasingEfficiencySummaryReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            orderDate: datevalue == null ? null : moment(datevalue).format('YYYY-MM-DD')
        }
        var res = await services.GetDailyPurchasingEfficiencySummaryReportDetails(model)
        res.forEach(x => {
            x.dtfccPurchaseValue = x.fccPurchaseValue
            x.dtnetAmount = x.netAmount
            x.dtpurchaseFromECValue = x.purchaseFromECValue
            if (x.mtdDetails.length > 0) {
                x.mtdDetails.forEach(y => {
                    x.mtdfccPurchaseValue = y.fccPurchaseValue
                    x.mtdnetAmount = y.netAmount
                    x.mtdpurchaseFromECValue = y.purchaseFromECValue
                })
            }
            else {
                x.mtdfccPurchaseValue = 0
                x.mtdnetAmount = 0
                x.mtdpurchaseFromECValue = 0
            }
            if (x.ytdDetails.length > 0) {
                x.ytdDetails.forEach(y => {
                    x.ytdfccPurchaseValue = y.fccPurchaseValue
                    x.ytdnetAmount = y.netAmount
                    x.ytdpurchaseFromECValue = y.purchaseFromECValue
                })
            }
            else {
                x.ytdfccPurchaseValue = 0
                x.ytdnetAmount = 0
                x.ytdpurchaseFromECValue = 0
            }
            x.dtValueSaving = x.dtpurchaseFromECValue == 0 ? 0 : x.dtpurchaseFromECValue - x.dtfccPurchaseValue
            x.dtSaving = x.dtValueSaving == 0 ? 0 : (x.dtValueSaving / x.dtfccPurchaseValue) * 100

            x.mtdValueSaving = x.mtdpurchaseFromECValue == 0 ? 0 : x.mtdpurchaseFromECValue - x.mtdfccPurchaseValue
            x.mtdSaving = x.mtdValueSaving == 0 ? 0 : (x.mtdValueSaving / x.mtdfccPurchaseValue) * 100

            x.ytdValueSaving = (x.ytdpurchaseFromECValue || 0) - (x.ytdfccPurchaseValue || 0);
            x.ytdSaving = x.ytdfccPurchaseValue
                ? (x.ytdValueSaving / x.ytdfccPurchaseValue) * 100
                : (x.ytdValueSaving ? 100 : 0);


            x.mtdNetProfit = x.mtdValueSaving == 0 ? 0 : x.mtdValueSaving - x.mtdCost
            x.ytdNetProfit = x.ytdValueSaving == 0 ? 0 : x.ytdValueSaving - x.ytdCost
        })
        const groupBy = (array, key) => {
            return array.reduce((result, currentItem) => {
                const groupKey = currentItem[key];
                if (!result[groupKey]) {
                    result[groupKey] = [];
                }
                result[groupKey].push(currentItem);
                return result;
            }, {});
        };
        const grouped = groupBy(res, 'factoryName');
        const groupedCustomerList = Object.entries(grouped).map(([key, items]) => ({
            factoryName: key,
            details: items.sort((a, b) => a.createdDate > b.createdDate ? 1 : -1)
        }));

        groupedCustomerList.sort((a, b) => a.factoryName > b.factoryName ? 1 : -1)
        let dtnetAmount = 0;
        let dtfccPurchaseValue = 0;
        let dtpurchaseFromECValue = 0;
        let dtValueSaving = 0;
        let dtSaving = 0;

        let mtdfccPurchaseValue = 0;
        let mtdpurchaseFromECValue = 0;
        let mtdValueSaving = 0;
        let mtdSaving = 0;

        let mtdCost = 0;
        let mtdNetProfit = 0;

        let ytdfccPurchaseValue = 0;
        let ytdpurchaseFromECValue = 0;
        let ytdValueSaving = 0;
        let ytdSaving = 0;

        let ytdCost = 0;
        let ytdNetProfit = 0;

        groupedCustomerList.forEach(x => {
            x.details.forEach(y => {
                x.dtnetAmount = x.dtnetAmount == undefined ? 0 + y.dtnetAmount : x.dtnetAmount + y.dtnetAmount;
                x.dtfccPurchaseValue = x.dtfccPurchaseValue == undefined ? 0 + y.dtfccPurchaseValue : x.dtfccPurchaseValue + y.dtfccPurchaseValue;
                x.dtpurchaseFromECValue = x.dtpurchaseFromECValue == undefined ? 0 + y.dtpurchaseFromECValue : x.dtpurchaseFromECValue + y.dtpurchaseFromECValue;
                x.dtValueSaving = x.dtValueSaving == undefined ? 0 + y.dtValueSaving : x.dtValueSaving + y.dtValueSaving;
                x.dtSaving = x.dtpurchaseFromECValue == 0 ? 0 : (x.dtValueSaving / x.dtpurchaseFromECValue) * 100;

                x.mtdfccPurchaseValue = y.mtdfccPurchaseValue;
                x.mtdpurchaseFromECValue = y.mtdpurchaseFromECValue;
                x.mtdValueSaving = y.mtdValueSaving;
                x.mtdSaving = x.mtdpurchaseFromECValue == 0 ? 0 : (x.mtdValueSaving / x.mtdpurchaseFromECValue) * 100;

                x.mtdCost = y.mtdCost;
                x.mtdNetProfit = y.mtdNetProfit;

                x.ytdfccPurchaseValue = y.ytdfccPurchaseValue;
                x.ytdpurchaseFromECValue = y.ytdpurchaseFromECValue;
                x.ytdValueSaving = y.ytdValueSaving;
                x.ytdSaving = x.ytdpurchaseFromECValue == 0 ? 0 : (x.ytdValueSaving / x.ytdpurchaseFromECValue) * 100;

                x.ytdCost = y.ytdCost;
                x.ytdNetProfit = y.ytdNetProfit;
            })
            dtnetAmount = dtnetAmount + x.dtnetAmount;
            dtfccPurchaseValue = dtfccPurchaseValue + x.dtfccPurchaseValue;
            dtpurchaseFromECValue = dtpurchaseFromECValue + x.dtpurchaseFromECValue;
            dtValueSaving = dtValueSaving + x.dtValueSaving;
            dtSaving = (dtValueSaving / dtfccPurchaseValue) * 100;

            mtdfccPurchaseValue = mtdfccPurchaseValue + x.mtdfccPurchaseValue;
            mtdpurchaseFromECValue = mtdpurchaseFromECValue + x.mtdpurchaseFromECValue;
            mtdValueSaving = mtdValueSaving + x.mtdValueSaving;
            mtdSaving = (mtdValueSaving / mtdfccPurchaseValue) * 100;

            mtdCost = mtdCost + x.mtdCost;
            mtdNetProfit = mtdNetProfit + x.mtdNetProfit;

            ytdfccPurchaseValue = ytdfccPurchaseValue + x.ytdfccPurchaseValue;
            ytdpurchaseFromECValue = ytdpurchaseFromECValue + x.ytdpurchaseFromECValue;
            ytdValueSaving = ytdValueSaving + x.ytdValueSaving;
            ytdSaving = (ytdValueSaving / ytdfccPurchaseValue) * 100;

            ytdCost = ytdCost + x.ytdCost;
            ytdNetProfit = ytdNetProfit + x.ytdNetProfit;
        })

        const totOfinterCenterBuyingExcellenceTotalSaving = groupedCustomerList.reduce((total, group) => {
            const groupTotal = group.details.reduce((sum, detail) => {
                return sum + (detail.interCenterBuyingExcellenceTotalSaving || 0);
            }, 0);
            return total + groupTotal;
        }, 0);

        const totNetSavingofFCCOperation = groupedCustomerList.reduce((total, group) => {
            const groupTotal = group.details.reduce((sum, detail) => {
                return sum + (detail.interCenterBuyingExcellenceTotalSaving || 0) + (detail.dtValueSaving || 0);
            }, 0);
            return total + groupTotal;
        }, 0);

        setTotalRow((prevState) => ({
            ...prevState,
            dtnetAmount: dtnetAmount,
            dtfccPurchaseValue: dtfccPurchaseValue,
            dtpurchaseFromECValue: dtpurchaseFromECValue,
            dtValueSaving: dtValueSaving,
            dtSaving: dtSaving,
            mtdfccPurchaseValue: mtdfccPurchaseValue,
            mtdpurchaseFromECValue: mtdpurchaseFromECValue,
            mtdValueSaving: mtdValueSaving,
            mtdSaving: mtdSaving,
            mtdCost: mtdCost,
            mtdNetProfit: mtdNetProfit,
            ytdfccPurchaseValue: ytdfccPurchaseValue,
            ytdpurchaseFromECValue: ytdpurchaseFromECValue,
            ytdValueSaving: ytdValueSaving,
            ytdSaving: ytdSaving,
            ytdCost: ytdCost,
            ytdNetProfit: ytdNetProfit,
            totOfinterCenterBuyingExcellenceTotalSaving: totOfinterCenterBuyingExcellenceTotalSaving,
            totNetSavingofFCCOperation: totNetSavingofFCCOperation
        }));
        setytdAndMtdDetails(groupedCustomerList);
        getSelectedDropdownValuesForReport(model);
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        getPermissions()
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYPURCHASINGEFFICIENCYSUMMARYREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)

        })
        trackPromise(GetAllGroups());

    }

    async function clearAll() {
        setDateValue(new Date());
        if (!permissionList.isFactoryFilterEnabled) {
            setSelectedOptions([]);
        } else {
            setSelectedOptions([]);
        }
    }

    useEffect(() => {
        trackPromise(GetAllGroups());
    }, []);


    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setytdAndMtdDetails([]);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setytdAndMtdDetails([]);
    }, [datevalue]);

    useEffect(() => {
        setytdAndMtdDetails([]);
    }, [selectedOptions]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions
        })
    }, [selectedOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(ytdAndMtdDetails);
        var settings = {
            sheetName: 'Daily Purchasing Efficiency Summary Report',
            fileName: 'Daily Purchasing Efficiency Summary Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: truncateSheetName('Daily Purchasing Efficiency Summary Report'),
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.forEach(x => {
                x.details.forEach(y => {
                    var vr = {
                        'FCC': x.factoryName,
                        'Saving for the day (Rs)': y.dtValueSaving == 0 ? '-' : parseFloat(y.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        '% Saving': y.dtSaving == 0 ? '-' : parseFloat(y.dtSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'MTD Value Saving (Rs)': y.mtdValueSaving == 0 ? '-' : parseFloat(y.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'MTD Saving %': y.mtdSaving == 0 ? '-' : parseFloat(y.mtdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'YTD Value Saving (Rs)': y.ytdValueSaving == 0 ? '-' : parseFloat(y.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'YTD Saving %': y.ytdSaving == 0 ? '-' : parseFloat(y.ytdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'Inter Center Buying Excellence (Rs)': y.interCenterBuyingExcellenceTotalSaving == 0 ? '-' : parseFloat(y.interCenterBuyingExcellenceTotalSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'Net Saving of the FCC Operation (Rs)': (y.interCenterBuyingExcellenceTotalSaving + y.dtValueSaving) == 0 ? '-' : parseFloat(y.interCenterBuyingExcellenceTotalSaving + y.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    }
                    res.push(vr);
                });
            });
            var vrTwo = {
                'FCC': 'Total Days Saving',
                'Saving for the day (Rs)': isNaN(total.dtValueSaving) || total.dtValueSaving === 0 ? '-' : parseFloat(total.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                '% Saving': isNaN(total.dtSaving) || total.dtSaving === 0 ? '-' : parseFloat(total.dtSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'MTD Value Saving (Rs)': total.mtdValueSaving == 0 ? '-' : parseFloat(total.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'MTD Saving %': isNaN(total.mtdSaving) || total.mtdSaving === 0 ? '-' : parseFloat(total.mtdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'YTD Value Saving (Rs)': isNaN(total.ytdValueSaving) || total.ytdValueSaving === 0 ? '-' : parseFloat(total.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'YTD Saving %': isNaN(total.ytdSaving) || total.ytdSaving === 0 ? '-' : parseFloat(total.ytdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Inter Center Buying Excellence (Rs)': isNaN(total.totOfinterCenterBuyingExcellenceTotalSaving) || total.totOfinterCenterBuyingExcellenceTotalSaving === 0 ? '-' : parseFloat(total.totOfinterCenterBuyingExcellenceTotalSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Net Saving of the FCC Operation (Rs)': isNaN(total.totNetSavingofFCCOperation) || total.totNetSavingofFCCOperation === 0 ? '-' : parseFloat(total.totNetSavingofFCCOperation).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vrTwo);
            res.push({});
            res.push({});
        }
        return res;
    }

    function getSelectedDropdownValuesForReport(data) {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });
        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues((prevState) => ({
            ...prevState,
            groupName: groups.groupName,
            factoryName: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(', '),
            date: new Date(datevalue).toLocaleDateString()
        }));
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? option.label : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? option.label : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Daily Purchasing Efficiency Summary Report |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group </MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            size="small"
                                            label="Date *"
                                            openTo="day"
                                            type="date"
                                            value={datevalue}
                                            onChange={(newValue) => {
                                                setDateValue(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                    <div>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </div>
                                </Stack>
                                <br />
                                <>
                                    {ytdAndMtdDetails.length != 0 ? (
                                        <>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} >
                                                <Card style={{ justifycontent: 'center' }}>
                                                    <Paper className={classes.paper}>
                                                        <TableContainer className={classes.tableContainer} sx={{ maxWidth: 1800 }}>
                                                            <Table size="small" aria-label="simple table" sx={{ width: 1150 }}>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell align="left" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>FCC</TableCell>
                                                                        <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Saving for the day (Rs)</TableCell>
                                                                        <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>%&nbsp;Saving</TableCell>
                                                                        <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>MTD&nbsp;Value Saving (Rs)</TableCell>
                                                                        <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>MTD&nbsp;Saving&nbsp;%</TableCell>
                                                                        <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>YTD&nbsp;Value Saving&nbsp;(Rs)</TableCell>
                                                                        <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>YTD&nbsp;Saving&nbsp;%</TableCell>
                                                                        <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Inter&nbsp;Center&nbsp;Buying Excellence&nbsp;(Rs)</TableCell>
                                                                        <TableCell align="right" style={{ fontWeight: "bold", verticalAlign: 'top', justifyContent: 'center' }}>Net&nbsp;Saving&nbsp;of&nbsp;the FCC&nbsp;Operation&nbsp;(Rs)</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {ytdAndMtdDetails.map((group, i) => (
                                                                        <React.Fragment key={i}>
                                                                            {group.details.map((detail, j) => {
                                                                                return (
                                                                                    <TableRow key={`${i}-${j}`}>
                                                                                        {j === 0 && (
                                                                                            <TableCell rowSpan={group.details.length} style={{ verticalAlign: 'top' }}>{group.factoryName}</TableCell>
                                                                                        )}
                                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                            {detail.dtValueSaving == 0 ? '-' : parseFloat(detail.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                            {detail.dtSaving == 0 ? '-' : parseFloat(detail.dtSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                            {detail.mtdValueSaving == 0 ? '-' : parseFloat(detail.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                            {detail.mtdSaving == 0 ? '-' : parseFloat(detail.mtdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                            {detail.ytdValueSaving == 0 ? '-' : parseFloat(detail.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                            {detail.ytdSaving == 0 ? '-' : parseFloat(detail.ytdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                            {detail.interCenterBuyingExcellenceTotalSaving == 0 ? '-' : parseFloat(detail.interCenterBuyingExcellenceTotalSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                                            {(detail.interCenterBuyingExcellenceTotalSaving + detail.dtValueSaving) == 0 ? '-' : parseFloat(detail.interCenterBuyingExcellenceTotalSaving + detail.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                );
                                                                            })}

                                                                        </React.Fragment>
                                                                    ))}
                                                                    <TableRow>
                                                                        <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'left' }}>
                                                                            Total Day's Saving
                                                                        </TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {isNaN(total.dtValueSaving) || total.dtValueSaving === 0 ? '-' : parseFloat(total.dtValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {isNaN(total.dtSaving) || total.dtSaving === 0 ? '-' : parseFloat(total.dtSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {isNaN(total.mtdValueSaving) || total.mtdValueSaving === 0 ? '-' : parseFloat(total.mtdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {isNaN(total.mtdSaving) || total.mtdSaving === 0 ? '-' : parseFloat(total.mtdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {isNaN(total.ytdValueSaving) || total.ytdValueSaving === 0 ? '-' : parseFloat(total.ytdValueSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {isNaN(total.ytdSaving) || total.ytdSaving === 0 ? '-' : parseFloat(total.ytdSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {isNaN(total.totOfinterCenterBuyingExcellenceTotalSaving) || total.totOfinterCenterBuyingExcellenceTotalSaving === 0 ? '-' : parseFloat(total.totOfinterCenterBuyingExcellenceTotalSaving).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                        <TableCell style={{ fontWeight: "bold", verticalAlign: 'top', textAlign: 'right', justifyContent: 'center' }}>
                                                                            {isNaN(total.totNetSavingofFCCOperation) || total.totNetSavingofFCCOperation === 0 ? '-' : parseFloat(total.totNetSavingofFCCOperation).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Paper>
                                                </Card>
                                            </Stack>
                                        </>
                                    )
                                        : <SearchNotFound searchQuery="Daily Purchasing Efficiency Summary Report" />}</>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {ytdAndMtdDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Daily Purchasing Efficiency Summary Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    ytdAndMtdDetails={ytdAndMtdDetails}
                                    searchData={selectedSearchValues}
                                    total={total}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}

